import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const PreWorkoutIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <path
        d="M21.6667 43.3335C33.6328 43.3335 43.3333 33.633 43.3333 21.6668C43.3333 9.70062 33.6328 0.00012207 21.6667 0.00012207C9.7005 0.00012207 0 9.70062 0 21.6668C0 33.633 9.7005 43.3335 21.6667 43.3335Z"
        fill="#DFBFA5"
      />
      <path
        d="M34.6117 15.337C34.4516 14.8115 33.8817 14.5303 33.3675 14.7235C33.1948 14.7885 33.0061 14.8593 32.8081 14.9333C32.274 15.1335 31.7852 15.4336 31.3643 15.8186C29.3124 17.6971 26.5045 19.7095 23.1286 20.7377C15.8272 22.9615 11.945 16.725 11.0964 15.1484L10.2363 16.9572C10.7013 17.5484 11.0796 18.2216 11.1309 18.8867C11.3851 22.1835 15.1242 28.522 24.6187 25.6303C28.3543 24.4925 33.0601 22.0022 34.6254 15.8535C34.6684 15.6843 34.6624 15.504 34.6117 15.337Z"
        fill="#FFE17D"
      />
      <path
        d="M34.6117 15.3372C34.5299 15.0688 34.3405 14.8655 34.1068 14.7552C33.2961 17.3776 31.8899 19.2858 30.2558 20.6873C27.9488 22.6659 24.9763 23.7054 21.9378 23.7676C21.8257 23.77 21.7141 23.7712 21.6024 23.7712C19.9927 23.7712 15.0615 23.2882 12.8545 17.6634C11.9518 16.6365 11.3674 15.6522 11.0964 15.1487L10.2363 16.9576C10.7013 17.5487 11.0796 18.2218 11.1309 18.8869C11.3851 22.1837 15.1242 28.5222 24.6187 25.6305C25.9023 25.2395 27.2988 24.6837 28.6435 23.8777C28.6441 23.8781 28.6449 23.8783 28.6455 23.8785C31.2163 22.343 33.598 19.8894 34.6254 15.8537C34.6684 15.6845 34.6624 15.5042 34.6117 15.3372Z"
        fill="#FFD164"
      />
      <path
        d="M33.3665 14.7235C33.2722 14.759 33.1727 14.7963 33.0703 14.8347L34.5122 16.2679C34.5511 16.1315 34.5886 15.9938 34.6243 15.8535C34.6673 15.6843 34.6614 15.504 34.6106 15.337C34.4505 14.8115 33.8806 14.5303 33.3665 14.7235Z"
        fill="#9F6C48"
      />
      <path
        d="M33.6136 21.7321C33.4222 21.7444 33.2129 21.7577 32.9935 21.7714C32.4012 21.8087 31.8238 21.959 31.2882 22.2149C28.677 23.4622 25.2728 24.6139 21.6013 24.6139C13.6612 24.6139 11.6879 17.2308 11.3213 15.4047C11.2664 15.131 11.1471 14.8749 10.97 14.6591L10.0962 13.5944C9.93812 13.4018 9.64851 13.3877 9.47236 13.5639L8.79019 14.2461C8.64618 14.3901 8.62456 14.6144 8.7404 14.7818C9.25853 15.5293 10.5624 17.6061 10.2226 19.1351C9.47633 22.4932 11.2763 29.9345 21.6013 29.9345C25.6638 29.9345 31.1017 28.8825 34.5229 23.2379C34.6172 23.0826 34.6659 22.9013 34.6659 22.7198C34.6659 22.1483 34.1839 21.6956 33.6136 21.7321Z"
        fill="#FFE17D"
      />
      <path
        d="M34.3406 21.9873C30.9001 27.0648 25.7213 28.0378 21.8125 28.0378C12.9064 28.0378 10.3342 22.5233 10.2675 18.8464C10.2584 18.9442 10.2441 19.0406 10.2231 19.1349C9.47685 22.493 11.2768 29.9342 21.6018 29.9342C25.6643 29.9342 31.1023 28.8823 34.5234 23.2376C34.6177 23.0823 34.6665 22.901 34.6665 22.7193C34.6665 22.4275 34.5397 22.1678 34.3406 21.9873Z"
        fill="#FFD164"
      />
      <path
        d="M11.1632 14.9582C11.1091 14.8526 11.046 14.7513 10.97 14.6586L10.0962 13.5942C9.93813 13.4016 9.64851 13.3875 9.47237 13.5635L8.79019 14.2458C8.64618 14.3899 8.62456 14.6142 8.7404 14.7816C8.95345 15.0889 9.2986 15.6223 9.60825 16.2485L11.1632 14.9582Z"
        fill="#9F6C48"
      />
      <path
        d="M33.6134 21.7319C33.5091 21.7387 33.3988 21.7456 33.2852 21.7527L34.2859 23.6158C34.3658 23.4918 34.4448 23.3664 34.523 23.2377C34.617 23.0824 34.6658 22.9011 34.6658 22.7196C34.6658 22.1481 34.1837 21.6954 33.6134 21.7319Z"
        fill="#9F6C48"
      />
    </SvgIcon>
  );
};

export default PreWorkoutIcon;
